const MIN_TOOLTIP_WIDTH = 180;
const MAX_TOOLTIP_WIDTH = 260;

export function verifiedBadgeTooltipWidth({
  viewportMargin,
  viewportWidth,
}: {
  viewportMargin: number;
  viewportWidth: number;
}) {
  return Math.min(
    MAX_TOOLTIP_WIDTH,
    Math.max(MIN_TOOLTIP_WIDTH, viewportWidth - viewportMargin * 2),
  );
}

export function verifiedBadgeTooltipLeftOffset({
  badgeWidth,
  badgeX,
  tooltipWidth,
  viewportMargin,
  viewportWidth,
}: {
  badgeWidth: number;
  badgeX: number;
  tooltipWidth: number;
  viewportMargin: number;
  viewportWidth: number;
}) {
  const centeredOffset = badgeWidth / 2 - tooltipWidth / 2;
  const minOffset = viewportMargin - badgeX;
  const maxOffset = viewportWidth - viewportMargin - tooltipWidth - badgeX;

  return Math.min(Math.max(centeredOffset, minOffset), maxOffset);
}
